module.exports = __webpack_public_path__ + "media/images/v3/b_3-7207c2c77daf00186b154606ae333d84.png";